var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex summary-container" },
    _vm._l(_vm.items, function(card) {
      return _c(
        "div",
        {
          key: card.key,
          class: [_vm.cardClass, { "summary-card--clickable": card.clickable }],
          attrs: {
            role: card.clickable ? "button" : null,
            tabindex: card.clickable ? 0 : null,
            "aria-label": card.clickable ? card.ariaLabel : null
          },
          on: {
            click: function($event) {
              return _vm.onCardClick(card)
            },
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onCardClick(card)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.onCardClick(card)
              }
            ]
          }
        },
        [
          _vm.loading
            ? [
                _c("BaseLoadingSkeleton", {
                  staticClass: "d-flex w-100 h-100",
                  staticStyle: { "min-height": "72px" },
                  attrs: { height: "100%" }
                })
              ]
            : _vm.styleCard === "bordered"
            ? [
                _c(
                  "div",
                  { staticClass: "summary-card__head" },
                  [
                    _c("span", { staticClass: "az-ds-body" }, [
                      _vm._v(_vm._s(card.label))
                    ]),
                    card.tooltip
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { right: "", "max-width": "360" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "icon-svg",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                name:
                                                  card.icon ||
                                                  "mdi-information",
                                                size: "16",
                                                color: "var(--muted)"
                                              }
                                            },
                                            "icon-svg",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(card.tooltip))])]
                        )
                      : card.icon
                      ? _c("icon-svg", {
                          attrs: {
                            name: card.icon,
                            size: 16,
                            color: "var(--muted)"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("span", { staticClass: "az-ds-kpi", class: card.class }, [
                  _vm._v(_vm._s(card.value))
                ]),
                _c("div", { staticClass: "summary-card__foot" }, [
                  card.variation
                    ? _c("span", { staticClass: "az-ds-badge-positive" }, [
                        _vm._v(" " + _vm._s(card.variation) + " ")
                      ])
                    : _vm._e(),
                  card.description
                    ? _c("span", { staticClass: "az-ds-aux" }, [
                        _vm._v(" " + _vm._s(card.description) + " ")
                      ])
                    : _vm._e()
                ]),
                card.observation
                  ? _c(
                      "span",
                      {
                        staticClass: "az-ds-aux summary-card__observation",
                        class: card.observationClass
                      },
                      [_vm._v(" " + _vm._s(card.observation) + " ")]
                    )
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-space-around align-center flex-column justify-center px-4",
                    class: card.description ? "py-4" : "py-6"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "summary-title text-center text-color-800"
                      },
                      [_vm._v(" " + _vm._s(card.label))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass:
                          "summary-subtitle text-center text-color-800"
                      },
                      [_vm._v(" " + _vm._s(card.description) + " ")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "az-paragraph font-semibold text-center",
                        class: _vm.getValueClass(card)
                      },
                      [_vm._v(" " + _vm._s(card.value) + " ")]
                    )
                  ]
                )
              ]
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }